











































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { IGuest } from "@/@types/admin/guest/user";
import { IRoomControl } from "@/@types/hotel/room";
import { ICruise } from "@/@types/cruiseOffers/cruiseList";

import InputSearch from "@/components/app/search/input-search.vue";
import ChangeDeleteButton from "@/components/buttons/change-delite-buttons.vue";
import ShowsGuestTableParams from "./params/shows-guest-table-params.vue";
import GuestTableTr from "./guest-table-tr.vue";
import StandartTable from "@/components/tables/standart-table.vue";

interface ISortColumn {
  room: number;
}

@Component({
  components: {
    InputSearch,
    "delete-btn": ChangeDeleteButton,
    params: ShowsGuestTableParams,
    "g-tr": GuestTableTr,
    StandartTable,
  },
})
export default class GuestTable extends Vue {
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;

  // shows
  @Prop({ type: Boolean, default: false }) show_comment!: boolean;
  @Prop({ type: Boolean, default: false }) show_gender!: boolean;
  @Prop({ type: Boolean, default: false }) show_email!: boolean;
  @Prop({ type: Boolean, default: false }) show_order_number!: boolean;
  @Prop({ type: Boolean, default: false }) show_ad!: boolean;
  @Prop({ type: Boolean, default: true }) show_room!: boolean;
  @Prop({ type: Boolean, default: true }) show_phone_number!: boolean;
  @Prop({ type: Boolean, default: true }) show_birthday!: boolean;
  @Prop({ type: Boolean, default: true }) show_document!: boolean;
  @Prop({ type: Boolean, default: true }) show_age!: boolean;
  @Prop({ type: Boolean, default: true }) show_check!: boolean;
  @Prop({ type: Boolean, default: true }) show_table!: boolean;
  @Prop({ type: Boolean, default: true }) show_zit!: boolean;
  @Prop({ type: String, default: "" }) wiev!: string;

  @Prop({ type: String, default: "" }) children!: string;
  @Prop({ type: Boolean, default: false }) pensioners!: boolean;
  @Prop({ type: String, default: "" }) birthday!: string;
  @Prop({ type: String, default: "" }) cruise_code!: string;
  @Prop({ type: String, default: "" }) gender!: string;
  @Prop({ type: String, default: "" }) doc_type!: string;
  @Prop({ type: String, default: "" }) citizenship!: string;
  @Prop({ type: String, default: "" }) room_type!: string;
  @Prop({ type: String, default: "" }) room_level!: string;
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  @Prop({ type: Array, default: () => [] }) citizenships!: Array<string>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;

  add_some = false;
  check_guests_id: Array<string> = [];

  sortKey = "";
  sortOrder: ISortColumn = { room: 1 };

  get guestList(): Array<IGuest> {
    if (!this.sortKey) return this.guests;
    const sort = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;

    return this.guests.slice().sort((a: IGuest, b: IGuest) => {
      switch (this.sortKey) {
        case "room": {
          const one = a.stay_data?.room.number ?? 0;
          const two = b.stay_data?.room.number ?? 0;
          return (one === two ? 0 : one > two ? 1 : -1) * sort;
        }
        default:
          return 0;
      }
    });
  }

  get colspan(): number {
    let c = 2;
    if (this.show_room) c++;
    if (this.show_age) c++;
    if (this.show_phone_number) c++;
    if (this.show_email) c++;
    if (this.show_document) c++;
    if (this.show_birthday) c++;
    if (this.show_ad) c += 2;
    if (this.show_order_number) c++;
    if (this.show_gender) c++;
    if (this.show_comment) c++;
    if (this.show_table) c++;
    if (this.show_zit && this.$store.getters.zit) c++;
    if (!this.wiev || this.wiev !== "plan") c++;
    return c;
  }

  get hasActiveSort(): boolean {
    return !!(
      this.children ||
      this.pensioners ||
      this.birthday ||
      this.cruise_code ||
      this.gender ||
      this.doc_type ||
      this.citizenship ||
      this.room_type ||
      this.room_level
    );
  }

  get childrenSortLabel(): string {
    if (!this.children) return "";
    const key = `Guests.List.sorts.children.${this.children}`;
    if (this.$te(key)) {
      return String(this.$t(key));
    }
    return this.children;
  }

  get cruiseCodeLabel(): string {
    if (!this.cruise_code || !this.cruises.length) return "";
    const cruise = this.cruises.find(
      (c: any) => String(c.id) === String(this.cruise_code)
    );
    return cruise ? this.$getLocale(cruise.name) : this.cruise_code;
  }

  get docTypeLabel(): string {
    return this.doc_type || "";
  }

  get citizenshipLabel(): string {
    return this.citizenship || "";
  }

  get roomTypeLabel(): string {
    if (!this.room_type || !this.roomTypes || !this.roomTypes.length) return "";
    const type = this.roomTypes.find((t: any) => t._id === this.room_type);
    return type ? this.$getLocale(type.name) : this.room_type;
  }

  get roomLevelLabel(): string {
    if (!this.room_level || !this.roomLevels || !this.roomLevels.length)
      return "";
    const level = this.roomLevels.find((l: any) => l._id === this.room_level);
    return level ? this.$getLocale(level.name) : this.room_level;
  }

  changeGuest(data: Partial<IGuest>, id: string): void {
    this.$emit("changeGuest", data, id);
  }

  checkGuest(guest_id: string | undefined): void {
    if (!guest_id) return;
    const i = this.check_guests_id.findIndex((id) => id == guest_id);
    if (i < 0) this.check_guests_id.push(guest_id);
    else this.check_guests_id.splice(i, 1);
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
  }

  deleteFromFront(id: string): void {
    this.$emit("deleteFromFronts", id);
  }

  checkInVroom(guest: Partial<IGuest>, id: string): void {
    this.$emit("check", guest, id);
  }

  editGuest(guest: IGuest): void {
    const roomId = guest.stay_data?.room?.id || "";
    this.$emit("change", guest._id, roomId);
  }
}
